import { render, staticRenderFns } from "./backtop.vue?vue&type=template&id=bd9b3d26&scoped=true&"
import script from "./backtop.vue?vue&type=script&lang=js&"
export * from "./backtop.vue?vue&type=script&lang=js&"
import style0 from "./backtop.vue?vue&type=style&index=0&id=bd9b3d26&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9b3d26",
  null
  
)

export default component.exports